import FAQAccordion from "../../components/FAQAccordion";
import { BobContent } from "../../data/bobContent";

const BobFAQ = ({ faq }: { faq: BobContent["faq"] }) => (
  <FAQAccordion id="bob-faq" eyebrow={faq.eyebrow} heading={faq.heading} items={faq.items} accentColor="bob.300" />
);

export default BobFAQ;
